<template>
<div>
  <b-card-actions action-collapse title="Liste des reçus">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <!-- <label class="mr-1">Recherche</label> -->
            <b-form-input
              placeholder="Recherche"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-sub-invoice"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
                <b-dropdown-item @click="UpdateReceipt(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Consulter reçu</span>
              </b-dropdown-item>
              <b-dropdown-item    @click="modalReceipt(props.row)"
                v-b-modal.modal-invoice>
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item @click="DeleteReceipt(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <span v-else-if="props.column.field == 'images'" class="dflex">
          <a
            v-for="(image, index) in props.row.images"
            :key="index"
            :href="imgFormat(image)"
            target="_blank"
            class="mlr10"
          >
            <b-img :src="imgFormat(image)" class="img-table"
          /></a>
        </span>
        <span v-else-if="props.column.field == 'description'">
          <p class="p-description">{{ props.row.description }}</p>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Afficher 1 à </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

  </b-card-actions>



    <b-modal
      v-model="showSubInvoice"
      id="modal-invoice"
      cancel-variant="outline-secondary"
      ok-title="Product"
      cancel-title="Close"
      centered
      size="xl"
      title="Créer réçu"
    >
      <b-row>
        <b-col md="1" xl="1" class="mb-1">
          <!-- basic -->
          <b-form-group label="C.Fac" label-for="code">
            <b-form-input
              id="code"
              placeholder="code"
              disabled
              v-model="selectedRowInvoice.code"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="Date" label-for="Date">
            <!-- <b-form-input
              id="Date"
              placeholder="Date"
              type="date"
              v-model="selectedRowInvoice.date"
            /> -->
            <flat-pickr
              v-model="selectedRowInvoice.date"
              class="form-control invoice-edit-input"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" xl="3" class="mb-1">
          <!-- basic -->
          <b-form-group label="Montant de la facture" label-for="price-invoice">
            <b-form-input
              v-currency="{
                currency: selectedRowInvoice.currency,
                valueRange: { min: 0 },
              }"
              id="price-invoice"
              placeholder="Montant de la facture"
              disabled
              v-model="selectedRowInvoice.total"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" xl="3" class="mb-1">
          <!-- basic -->
          <b-form-group
            label="Montant du règlement"
            label-for="price-subInvoice"
          >
            <b-form-input
              v-currency="{
                currency: selectedRowInvoice.currency,
                valueRange: { min: 0 },
              }"
              id="price-subInvoice"
              placeholder="Montant du règlement"
              v-model="selectedRowInvoice.price"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" xl="3" class="mb-1">
          <!-- basic -->
          <b-form-group label="Solde à payer" label-for="price">
            <b-form-input
              v-currency="{
                currency: selectedRowInvoice.currency,
                valueRange: { min: 0 },
              }"
              id="price"
              placeholder="Solde à payer"
              disabled
              :value="
                getPriceToPay(
                  selectedRowInvoice.total,
                  selectedRowInvoice.price
                )
              "
            />
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            size="md"
            @click="updateSubInvoice(), (showSubInvoice = false)"
          >
            Modifier reçu
          </b-button>
        </div>
      </template>
    </b-modal>

    </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BModal,
  VBModal,
  BForm,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import { forEach } from 'postcss-rtl/lib/affected-props';
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BModal,
    VBModal,
    BForm,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      showSubInvoice: false,
      show: false,
      pageLength: 5,
      pageLengthModal: 5,
      dir: false,
      /* columnsModal: [
        {
          label: "Code",
          field: "code",
          filterOptions: {
            enabled: true,
            placeholder: "#1234",
          },
        },
        {
          label: "Quantité",
          field: "quantity",
          filterOptions: {
            enabled: true,
            placeholder: "Quantié",
          },
        },
        {
          label: "Prix sans tax",
          field: "product.priceWithoutTaxes",
          filterOptions: {
            enabled: true,
            placeholder: "Prix sans tax",
          },
        },
        {
          label: "Remise",
          field: "discount",
          filterOptions: {
            enabled: true,
            placeholder: "Remise",
          },
        },
        {
          label: "Tax",
          field: "valueAddedTax",
          filterOptions: {
            enabled: true,
            placeholder: "Tax",
          },
        },
      ], */
      columns: [
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Code",
          field: "code",
          filterOptions: {
            enabled: true,
            placeholder: "Code",
          },
        },
        {
          label: "État",
          field: "status",
          filterOptions: {
            enabled: true,
            placeholder: "État",
          },
        },
        {
          label: "Client",
          field: "customer",
          formatFn: this.customerFormat,
          filterOptions: {
            enabled: true,
            placeholder: "Client",
          },
        },
        {
          label: "Date de livraison",
          field: "deliveryDate",
          formatFn: this.dateFormat,
          filterOptions: {
            enabled: true,
            placeholder: "Date de livraison",
          },
        },

        {
          label: "Totale TTC",
          field: "total",
          filterOptions: {
            enabled: true,
            placeholder: "100",
          },
        },
        {
          label: "Montant du règlement",
          field: "price",
          filterOptions: {
            enabled: true,
            placeholder: "20",
          },
        },
        {
          label: "Solde à payer",
          field: "remaining",
          filterOptions: {
            enabled: true,
            placeholder: "80",
          },
        },
        {
          label: "Date d'insertion",
          field: "date",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          filterOptions: {
            enabled: true,
            placeholder: "Agent de saisie",
          },
          formatFn: this.createdByFormat,
        },
      ],
      rows: [],
      rowModal: [],
      searchTerm: "",
      selectedRowInvoice: {},
    };
  },
  async created() {
    await this.getAllBillReceipts();
  },
  methods: {
    advanceSearch(val) {
      this.searchTerm = val;
    },
    // Start To => utils************************************************
    priceFormat(price) {
      if (price) {
        return Number.parseFloat(price).toFixed(3);
      }
    },
    imgFormat: function (value) {
      if (value) {
        return (
          "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
          value +
          ".png"
        );
      }
    },
    createdByFormat: function (value) {
      if (value != null) {
        return value.firstName + " " + value.lastName;
      }
    },
    customerFormat: function (value) {
      if (value != null) {
        return value.firstName + " " + value.lastName;
      }
    },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    // table Format
    tableFormat: function (value) {
      const table = value.map((element) => {
        return element.label;
      });
      return table.toString();
    },
    // name agent de saisie
    nameFormat: function (value) {
      if (value != null) {
        return value.firstName + " " + value.lastName;
      }
    },
    // End To => utils************************************************
    getPriceToPay(allTaxesIncluded, receiptPrice) {
      if(allTaxesIncluded && receiptPrice){
        if (allTaxesIncluded < receiptPrice) {
          return 0;
        } else {
          return parseFloat(allTaxesIncluded) - parseFloat(receiptPrice);
        }
      }else{
        return allTaxesIncluded
      }
    },
    async updateSubInvoice() {
      console.log(this.selectedRowInvoice);
      await axios
        .put(
          "https://management-projects.herokuapp.com/api/sales-bills/" +
            this.selectedRowInvoice.id +
            "/receipts",
          { receipt: this.selectedRowInvoice }
        )
        .then((response) => {
          console.log(response);
           this.$toast({
            component: ToastificationContent,
            props: {
              title: `Recu bien modifié`,
              icon: "UserIcon",
              variant: "success",
            },
          });       
        })
        .catch((error) => {
          this.errorMessage = error.message;
           this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la modification`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
        });
    },
    modalReceipt(row) {
      console.log(row);
      this.selectedRowInvoice = {
        id:row._id,
        total: row.total,
        code: row.code,
        date: new Date(row.date),
        price: row.price,
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
        currency: row.currency || "TND",
      };

    },
    async getAllBillReceipts() {
      const response = await axios
        .get("https://management-projects.herokuapp.com/api/sales-receipts?bill="+this.$router.history.current.query.id)
        .then((response) => {
          console.log(response);
          this.rows = response.data;
          this.rows.forEach(element => {
            element.remaining = parseFloat(element.total) - parseFloat(element.price);
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    DeleteReceipt(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer ce Reçu ?",
        text: "Vous ne pourrez pas annuler cela!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var payload = {
            deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
          };
          axios
            .delete(
              `https://management-projects.herokuapp.com/api/sales-bills/${this.$router.history.current.query.id}/receipts/${id}`
            )
            .then((response) => {
              this.getAllBillReceipts();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Reçu bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de la suppression`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    UpdateReceipt(id) {
      console.log(id);
      var routerLink = "/sale/sub-invoice/preview-sub-invoice?id=" + id + "&bill=" + this.$router.history.current.query.id;
      this.$router.replace(routerLink);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}

.p-description {
  height: 60px;
  width: 250px;
  overflow: auto;
}
.barcode-size svg {
  height: 80px;
}
</style>
